import React from "react";
import {
  Badge,
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Typography,
} from "@mui/material";
import { motion } from "framer-motion"; // Import Framer Motion

// Animation Variants
const boxVariants = {
  hidden: { opacity: 0, scale: 0.8, y: -50 },
  visible: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: { duration: 0.7, ease: "easeOut" },
  },
};

const buttonVariants = {
  hidden: { opacity: 0, x: -100 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.5, ease: "easeOut", delay: 0.2 },
  },
};

const cardVariants = {
  hidden: {
    opacity: 0,
    y: 50,
    scale: 0.95,
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.7,
      ease: "easeOut",
    },
  },
  hover: {
    scale: 1.05,
    transition: {
      duration: 0.3,
    },
  },
};

const cardMediaVariants = {
  hidden: { opacity: 0, scale: 0.5, rotate: -10 },
  visible: {
    opacity: 1,
    scale: 1,
    rotate: 0,
    transition: { duration: 0.8, ease: "easeOut" },
  },
};

const cardContentVariants = {
  hidden: {
    opacity: 0,
    scale: 0.8,
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.7,
      ease: "easeOut",
    },
  },
  hover: {
    scale: 1.1,
    transition: {
      duration: 0.4,
    },
  },
};

const textVariants = {
  hidden: { opacity: 0, x: 50 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

const MotionBadge = motion.create(Badge);
const MotionBox = motion.create(Box);
const MotionButton = motion.create(Button);
const MotionCard = motion.create(Card);
const MotionCardContent = motion.create(CardContent);
const MotionCardMedia = motion.create(CardMedia);
const MotionTypography = motion.create(Typography);

export const MotionBoxComponent = ({
  children,
  variants = boxVariants,
  initial = "hidden",
  whileInView = "visible",
  viewport = { once: true },
  ...props
}) => (
  <MotionBox
    variants={variants}
    initial={initial}
    whileInView={whileInView}
    viewport={viewport}
    {...props}
  >
    {children}
  </MotionBox>
);

export const MotionBadgeComponent = ({
  children,
  variants = textVariants,
  initial = "hidden",
  whileInView = "visible",
  viewport = { once: true },
  ...props
}) => (
  <MotionBadge
    variants={variants}
    initial={initial}
    whileInView={whileInView}
    viewport={viewport}
    {...props}
  >
    {children}
  </MotionBadge>
);

export const MotionButtonComponent = ({
  children,
  variants = buttonVariants,
  initial = "hidden",
  whileInView = "visible",
  viewport = { once: true },
  ...props
}) => (
  <MotionButton
    variants={variants}
    initial={initial}
    whileInView={whileInView}
    viewport={viewport}
    {...props}
  >
    {children}
  </MotionButton>
);

export const MotionCardComponent = ({
  children,
  variants = cardVariants,
  initial = "hidden",
  whileInView = "visible",
  viewport = { once: true },
  ...props
}) => (
  <MotionCard
    variants={variants}
    initial={initial}
    whileInView={whileInView}
    viewport={viewport}
    {...props}
  >
    {children}
  </MotionCard>
);

export const MotionCardContentComponent = ({
  children,
  variants = cardContentVariants,
  initial = "hidden",
  whileInView = "visible",
  viewport = { once: true },
  ...props
}) => (
  <MotionCardContent
    variants={variants}
    initial={initial}
    whileInView={whileInView}
    viewport={viewport}
    {...props}
  >
    {children}
  </MotionCardContent>
);

export const MotionCardMediaComponent = ({
  children,
  variants = cardMediaVariants,
  initial = "hidden",
  whileInView = "visible",
  viewport = { once: true },
  ...props
}) => (
  <MotionCardMedia
    variants={variants}
    initial={initial}
    whileInView={whileInView}
    viewport={viewport}
    {...props}
  >
    {children}
  </MotionCardMedia>
);

export const MotionTypographyComponent = ({
  children,
  variants = textVariants,
  initial = "hidden",
  whileInView = "visible",
  viewport = { once: true },
  ...props
}) => (
  <MotionTypography
    variants={variants}
    initial={initial}
    whileInView={whileInView}
    viewport={viewport}
    {...props}
  >
    {children}
  </MotionTypography>
);
